import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const reporting = {
    label: "Reporting",
    pageLabel: "Reporting",
    starting: true,
    url: "reporting",
    pageType: "history",
    form: [
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Select Booth",
        description: "Select Booth"
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-lg-4",
          children: "col-lg-12"
        },
        options: [],
        ajaxLoad: true,
        handleSelection:true,
        getHotname:"reporting",
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getBoothEleVoter",
            fieldType: "string",
            filters: ["pageData", "boothno"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Select Booth",
        name: "boothno",
        description: "Enter Booth"
    },
          {
            inputType: "handsonTable",
            widths: {
              parent: "col-lg-12",
              children: "col-lg-12"
            },
            // headers:["Car", "Model", "Number", "Date"],
            // data:[],
            label: "Reporting",
            name: "reporting",
            description: "Select Voted Status",
            reduiredValue:['srno','firstName','middleName','lastName','VoterID','circle.value','subCircle.value','village.value',"mobilenumber1"],
            // getHotname:"reporting",
            tableOptions: {
              // validations, basic calculations, colors, date pickers, context menu etc.
              HOTheaders: [
                "Sr No",
                "Name",
                "Voter ID", 
                "Circle",
                "Sub Circle",
                "Village",
                "Mobile No",
                "Booth Pramukh",
                "Status",
                
              ],
              columns: [
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },                
                { type: "text" },
                { type: "text" },
                {
                    type: "dropdown",
                    source: [] 
                },
                
              ],
              // rowHeaders: true,
              contextMenu: true,
              minSpareRows: 1,
              width: 1200,
              height: 400,
              stretchH: "all",
              columnSorting: true,
              autoWrapRow: true,
              maxRows: 100,
              manualRowResize: true,
              manualColumnResize: true,
              headerTooltips: true
              // nestedHeaders: [
              //   ['Item', {label: 'Vendor 1', colspan: 3}, {label: 'Vendor 2', colspan: 3}],
              //   // ['D', {label: 'E', colspan: 4}, {label: 'F', colspan: 4}, 'G'],
              //   // ['H', {label: 'I', colspan: 2}, {label: 'J', colspan: 2}, {label: 'K', colspan: 2}, {label: 'L', colspan: 2}, 'M'],
              //   ['Item', 'Q', 'R', 'P', 'Q', 'R', 'P']
              // ],
            }
          },











               

         
    ],
    history: {
      perPage: 10,
      displayColumns: [
        // {
        //   Header: "Booth No.",
        //   accessor: "boothno",
        // },
        {
          Header: "Booth Number",
          accessor: "boothno.value",
        },
        // {
        //   Header: "P-Volunteer",
        //   accessor: "pvolunteer",
        // },
        // {
        //   Header: "E-Volunteer",
        //   accessor: "evolunteer",
        // },
       
      ]
    },
  report: {
      perPage: 10,
      queryType: "mysqlQuery",
      //   groupBy: ["schedule","subschedule"],
      query: [
        {
          dialect: "mysql",
          seq: 1,
          columnHeader: [
            {
              id: "balance1",
              headerText: "trdate",
              headerFrom: "balance"
            }
          ],
          query: ""
        }
      ],
      displayColumns: [
        
        
      ]
    }
  }
  export default reporting;